import { ContentHeaderService, ContentHeaderServiceModule } from '@b2b/common/services/contentHeader';
import { ACMEResponse, TODO } from '@b2b/types/core';
import uiRouter, { StateParams } from '@uirouter/angularjs';
import angular, { IHttpService, IScope } from 'angular';
import { AppStoreComponentModule } from '../components/app-store';

export function getAppStoreEnv(config: ACMEConfig, useSandboxRegistry: boolean): 'sandbox' | 'production' {
  if (useSandboxRegistry && config.environment === 'sandbox') {
    return 'sandbox';
  }

  switch (config.environment) {
    case 'development':
      return 'sandbox';

    default:
      return 'production';
  }
}

export interface AppStoreTokenResponse {
  token: string;
}

AppStoreController.$inject = ['$scope', '$window', '$http', '$stateParams', 'ContentHeaderService'];

export function AppStoreController(
  $scope: IScope & { appStore: TODO },
  $window: Window,
  $http: IHttpService,
  $stateParams: StateParams,
  contentHeaderService: ContentHeaderService,
) {
  const useSandboxRegistry = $stateParams.useSandboxRegistry === 'true';

  const ctrl = {
    state: 'loading' as 'loading' | 'error' | 'ready',
    apiKey: '' as string,
    env: getAppStoreEnv($window.CONFIG, useSandboxRegistry),
    appId: ($stateParams.appId as string) || '',

    init() {
      contentHeaderService.update({ title: 'Integration & Apps' });

      ctrl
        .fetchToken()
        .then((apiKey) => {
          ctrl.apiKey = apiKey;
          ctrl.state = 'ready';
        })
        .catch(() => {
          ctrl.state = 'error';
        });
    },

    handleAppStoreError(error: Error) {
      console.error('AppStore error:', error);
      ctrl.state = 'error';
    },

    fetchToken() {
      return $http.post<ACMEResponse<AppStoreTokenResponse>>('/v2/api/app-store/token', {}).then((response) => {
        if (!response.data.success || !response.data.payload?.token) {
          throw new Error('Failed to fetch app store token');
        }
        return response.data.payload.token;
      });
    },
  };

  $scope.appStore = ctrl;
  ctrl.init();
}

export const AppStoreControllerModule = angular
  .module('acme.view.application.app-store.controllers', [
    uiRouter,
    'ui.bootstrap',
    ContentHeaderServiceModule,
    AppStoreComponentModule,
  ])
  .controller('AppStoreController', AppStoreController).name;
